import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { BusyService } from 'app/core/busy/busy.service';

/** Mostra il loader bloccante per le richieste lente: i salvataggi dopo poco, le semplici letture solo se davvero lente. */
export const busyInterceptor: HttpInterceptorFn = (req, next) =>
{
    const busy = inject(BusyService);
    const done = busy.start(req.method === 'GET' ? 1500 : 300);
    return next(req).pipe(finalize(done));
};
